export default "assets/images/pattern-5d62b969.png";